import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-payment-layout',
  templateUrl: './report-payment-layout.component.html',
  styleUrls: ['./report-payment-layout.component.css']
})
export class ReportPaymentLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
